import { authClient, API } from "../index";

export const getBrevoTemplates = () => {
  return authClient().get(`${API}/brevo/templates`);
};

export const sendBrevoEmail = (body) => {
  return authClient().post(`${API}/brevo`, body);
};
